const featuresData = [
  {
    icon: 'ri-notification-3-line',
    title: '智能更新提醒',
    desc: '关注即推送，连载漫画最新章节上线第一时间通知你，漫画更新提醒永不错过。',
  },
  {
    icon: 'ri-book-read-line',
    title: '免费漫画全集',
    desc: '平台收录的全部漫画资源均可免费阅读，无需付费即可畅享最新漫画更新。',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '追更实时榜单',
    desc: '热度、更新、讨论多维榜单，最新漫画更新动态一目了然，发现热门追更漫画。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步追漫',
    desc: '桌面端与移动端无缝切换，随时随地追更连载漫画，追漫必备的跨端体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全绿色阅读',
    desc: '干净无广告的阅读环境，专注漫画追更体验，不被弹窗和恶意跳转打扰。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            为什么选择UU漫画
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            五大核心优势，打造最好的漫画追更体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featuresData.map((f) => (
            <div
              key={f.title}
              className="bg-background-100 rounded-xl p-6 flex flex-col items-center text-center hover:scale-[1.02] transition-transform"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-50 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}